import { WIDGET_APPOINTMENT_TYPE } from '../constants/widget-constants';
import { LanguageDao } from '../db-models/language.model';
import { PartnerDao, WidgetTimeFormat } from '../db-models/widget-conf-dao';
import { CountryDbModel } from './country.model';
import { CaptchaType, Subscription } from './global';

export class WidgetConf {
  id: number;
  uuid: string;
  name: string;
  bookingName: string;
  logo: string;
  currency: string;
  url: string;
  // Need to check the type boolean or number
  isBusiness: number;
  headerBgColor: string;
  footerBgColor: string;
  textColor: string;
  footerBtnColor: string;
  headerActiveColor: string;
  // Need to check the type boolean or number
  appointmentBookingEnabled: boolean;
  // Need to check the type boolean or number
  eventBookingEnabled: boolean;
  // Need to check the type boolean or number
  resourceBookingEnabled: boolean;
  token: string;
  languageCode: string;
  ical_hash: string;
  backgroundColor: string;
  // Need to check the type boolean or number
  showEgalWer: boolean;
  countryCode: string;
  // Need to check the type boolean or number
  needCustomerAddress: boolean;
  needPhoneNumber: boolean;
  needMobileNumber: boolean;
  show_message_on_widget: number;
  cartSupported: boolean;
  courtesyForm: string;
  appointmentLeadTime: number;
  eventLeadTime: number;
  appointmentBookingInfo: string;
  eventSlotBookingInfo: string;
  whitelabel?: boolean;
  subscriptionTypeId: number;
  hide_login_on_bookingsite: number;
  hide_back_on_bookingsite: number;
  widget_buttons_always_enabled: number;
  hide_book_additional_appointment_button: number;
  allow_multiple_services_bookings: number;
  hide_widget_cart_functionality_message: number;
  supported_widget_languages: string[];
  subscription: Subscription;
  show_stores_as_dropdown: number;
  hide_event_capacity: number;
  scroll_to_element_feature_is_enabled: number;
  has_valid_coupons: number;
  is_widget_postcode_worker_random_selection_enabled: number;
  language: LanguageDao
  language_id: number;
  language_identifier: string;
  show_widget_slot_location: number;
  widget_jumps_to_resources_step_when_single_service: number;
  is_appointment_reservation_enabled: number;
  x_minutes_appointment_reservation: number;
  split_personal_form_and_summary_in_widget: number;
  show_cross_selling_services_on_summary_step: number;
  cross_selling_services_category_filter: number;
  show_widget_calendar_notice: number;
  widget_birthday_shown: number;
  widget_birthday_required: number;
  widget_birthday_minimum_age_18: number;
  widget_vat_type: string;
  enable_phishing_protection: boolean;
  phishing_protection_regex: string;
  is_captcha_feature_enabled: number;
  captcha_type: CaptchaType;
  friendly_captcha_sitekey: string;
  is_widget_password_protection_setting_enabled: number;
  is_customer_authentication_enabled: number;
  widget_protection_type: string; // password, otp
  otp_verification_type: string; // email, sms
  otp_complexity: string; // low, medium, high
  otp_restricted_components: string; // appointment_booking,appointment_cancellation,admin_appointment_cancellation,appointment_rebook,admin_appointment_rebook
  restrict_customer_data_filling: number;
  enable_widget_restriction: number;
  widget_restriction_parameters: string; // customer,worker,store,service
  widget_time_format: WidgetTimeFormat;
  is_zip_codes_search_enabled: number;

  public static createWidgetConfObject(partnerDao: PartnerDao): WidgetConf {
    const widgetConf = new WidgetConf();
    widgetConf.id = partnerDao.id;
    widgetConf.uuid = partnerDao.uuid;
    widgetConf.name = partnerDao.name;
    widgetConf.bookingName = partnerDao.booking_name;
    widgetConf.logo = partnerDao.logo;
    widgetConf.currency = partnerDao.currency;
    widgetConf.url = partnerDao.url;
    widgetConf.isBusiness = partnerDao.is_business;
    widgetConf.headerBgColor = partnerDao.widget_header_background_color;
    widgetConf.footerBgColor = partnerDao.widget_footer_background_color;
    widgetConf.textColor = partnerDao.widget_text_color;
    widgetConf.footerBtnColor = partnerDao.widget_footer_button_color;
    widgetConf.headerActiveColor = partnerDao.widget_header_active_color;
    widgetConf.appointmentBookingEnabled = partnerDao.widget_type_preferences?.includes(WIDGET_APPOINTMENT_TYPE.EXTERNAL_APPOINTMENT);
    widgetConf.eventBookingEnabled = partnerDao.widget_type_preferences?.includes(WIDGET_APPOINTMENT_TYPE.EXTERNAL_GROUP_APPOINTMENT);
    widgetConf.resourceBookingEnabled = partnerDao.resource_booking_enabled === 0 ? false : true;
    widgetConf.token = partnerDao.token;
    widgetConf.languageCode = partnerDao.language.identifier;
    widgetConf.ical_hash = partnerDao.ical_hash;
    widgetConf.backgroundColor = partnerDao.widget_background_color;
    widgetConf.showEgalWer = partnerDao.egal_wer_show === 0 ? false : true;
    widgetConf.countryCode = partnerDao.country.identifier;
    widgetConf.needCustomerAddress = partnerDao.show_address_on_widget === 0 ? false : true;
    widgetConf.needPhoneNumber = partnerDao.show_phone_on_widget === 0 ? false : true;
    widgetConf.needMobileNumber = partnerDao.show_mobile_on_widget === 0 ? false : true;
    widgetConf.show_message_on_widget = Number(partnerDao.show_message_on_widget);
    widgetConf.cartSupported = partnerDao.is_cart_supported === 0 ? false : true;
    widgetConf.courtesyForm = partnerDao.courtesy_form;
    widgetConf.appointmentLeadTime = partnerDao.appointment_lead_time;
    widgetConf.eventLeadTime = partnerDao.event_lead_time;
    widgetConf.appointmentBookingInfo = partnerDao.appointment_booking_info;
    widgetConf.eventSlotBookingInfo = partnerDao.event_slot_booking_info;
    widgetConf.subscriptionTypeId = partnerDao.subscription.subscription_type_id;
    widgetConf.hide_login_on_bookingsite = partnerDao.hide_login_on_bookingsite;
    widgetConf.hide_back_on_bookingsite = partnerDao.hide_back_on_bookingsite;
    widgetConf.widget_buttons_always_enabled = Number(partnerDao.widget_buttons_always_enabled ?? 0);
    widgetConf.hide_book_additional_appointment_button = partnerDao.hide_book_additional_appointment_button;
    widgetConf.allow_multiple_services_bookings = partnerDao.allow_multiple_services_bookings;
    widgetConf.hide_widget_cart_functionality_message = partnerDao.hide_widget_cart_functionality_message;
    widgetConf.supported_widget_languages = partnerDao.supported_widget_languages;
    widgetConf.subscription = partnerDao.subscription;
    widgetConf.show_stores_as_dropdown = Number(partnerDao.show_stores_as_dropdown);
    widgetConf.hide_event_capacity = Number(partnerDao.hide_event_capacity);
    widgetConf.scroll_to_element_feature_is_enabled = Number(partnerDao.scroll_to_element_feature_is_enabled);
    widgetConf.has_valid_coupons = partnerDao.has_valid_coupons;
    widgetConf.is_widget_postcode_worker_random_selection_enabled = Number(partnerDao.is_widget_postcode_worker_random_selection_enabled);
    widgetConf.language = partnerDao.language;
    widgetConf.language_id = Number(partnerDao.language_id);
    widgetConf.language_identifier = partnerDao.language_identifier;
    widgetConf.show_widget_slot_location = partnerDao.show_widget_slot_location;
    widgetConf.widget_jumps_to_resources_step_when_single_service = partnerDao.widget_jumps_to_resources_step_when_single_service;
    widgetConf.is_appointment_reservation_enabled = partnerDao.is_appointment_reservation_enabled;
    widgetConf.x_minutes_appointment_reservation = partnerDao.x_minutes_appointment_reservation;
    widgetConf.split_personal_form_and_summary_in_widget = partnerDao.split_personal_form_and_summary_in_widget;
    widgetConf.show_cross_selling_services_on_summary_step = partnerDao.show_cross_selling_services_on_summary_step;
    widgetConf.cross_selling_services_category_filter = Number(partnerDao.cross_selling_services_category_filter ?? 0);
    widgetConf.show_widget_calendar_notice = partnerDao.show_widget_calendar_notice;
    widgetConf.widget_birthday_shown = partnerDao.widget_birthday_shown;
    widgetConf.widget_birthday_required = partnerDao.widget_birthday_required;
    widgetConf.widget_birthday_minimum_age_18 = partnerDao.widget_birthday_minimum_age_18;
    widgetConf.widget_vat_type = partnerDao.widget_vat_type;
    widgetConf.enable_phishing_protection = partnerDao.enable_phishing_protection;
    widgetConf.phishing_protection_regex = partnerDao.phishing_protection_regex;
    widgetConf.is_captcha_feature_enabled = partnerDao.is_captcha_feature_enabled;
    widgetConf.captcha_type = partnerDao.captcha_type;
    widgetConf.friendly_captcha_sitekey = partnerDao.friendly_captcha_sitekey;
    widgetConf.is_widget_password_protection_setting_enabled = partnerDao.is_widget_password_protection_setting_enabled;
    widgetConf.is_customer_authentication_enabled = partnerDao.is_customer_authentication_enabled;
    widgetConf.widget_protection_type = partnerDao.widget_protection_type;
    widgetConf.otp_verification_type = partnerDao.otp_verification_type;
    widgetConf.otp_complexity = partnerDao.otp_complexity;
    widgetConf.otp_restricted_components = partnerDao.otp_restricted_components;
    widgetConf.restrict_customer_data_filling = partnerDao.restrict_customer_data_filling;
    widgetConf.enable_widget_restriction = partnerDao.enable_widget_restriction;
    widgetConf.widget_restriction_parameters = partnerDao.widget_restriction_parameters;
    widgetConf.widget_time_format = partnerDao.widget_time_format;
    widgetConf.is_zip_codes_search_enabled = partnerDao.is_zip_codes_search_enabled;
    return widgetConf;
  }
}

export class CssOverwrites {
  id: number;
  uuid: string;
  name: string;
  code: string;
  type: string;
  is_active: number;
  partner_id: number;
  errors?: any;
}

export class CustomerPrefillDataModel {
  title: string;
  prename: string;
  lastname: string;
  email: string;
  mobile: string;
  phone: string;
  id: string;
  street: string;
  gender: string;
  zip: string;
  city: string;
  country_id: number;
  country: CountryDbModel;
  comment: string;
  company: string;
  birthday: string;
}

export enum CUSTOM_CSS_WIDGET_TYPE {
  widget = 'widget',
  smart_widget = 'smart_widget',
  compact_widget = 'compact_widget'
}
